$(document).ready(function () {
	$('.c-block01').each(function (index) {
		// IDを 'link' + 連番で設定する
		var idValue = 'link' + ('0' + (index + 1)).slice(-2); // 2桁の連番
		$(this).attr('id', idValue);
	});
});
